import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AboutInternship.css'; // import the css

const AboutInternship = () => {
  const navigate = useNavigate();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <div className={`about-container ${fadeIn ? 'fade-in' : ''}`}>
      <button
        onClick={() => navigate('/register')}
        className="back-button"
      >
        ← Back to Registration
      </button>

      <h1 className="about-heading">Virtual Internship & Training Program</h1>
      <p className="tagline">Organized by CVEY Solutions Pvt. Ltd.</p>

      <section className="about-section program-overview">
        <h2>Program Overview</h2>
        <p><strong>Duration:</strong> 2 Months (Virtual Mode)</p>
        <p><strong>Position:</strong> Trainee Programmer</p>
        <p><strong>Fee:</strong> Rs. 2000 for the entire duration</p>
      </section>

      <section className="about-section">
        <h2>Benefits</h2>
        <ul className="benefits-list">
          <li>Internship Certificate</li>
          <li>Hands-on Practice with Frontend, Backend, and Database Technologies:</li>
          <ul className="sub-list">
            <li><strong>Frontend:</strong> HTML, CSS, JavaScript, React</li>
            <li><strong>Backend:</strong> Node.js, Express.js</li>
            <li><strong>Database:</strong> SQLite</li>
          </ul>
          <li>Experience with API Integration</li>
          {/* <li>Work on Live Web Applications</li> */}
          <li>Develop Problem-Solving and Debugging Skills</li>
          <li>Learn Version Control with Git and GitHub</li>
          <li><strong>Bonus:</strong> Learn Python Basics as an extra skill</li>
        </ul>
      </section>
      <section className="about-section">
        <h2>Important Dates</h2>
        <ul className="dates-list">
          <li>Deadline for Registration: 17th October(Friday), 2025</li>
          <li>Interview Session: 19th October(sunday), 2025</li>
          <li>Final Announcement: 14th November, 2025</li>
          <li>Internship timings: 6:00PM-8:00PM</li>
        </ul>
      </section>
      <section className="about-section">
        <h2>Training Curriculum</h2>
        <div className="curriculum-grid">
          <div>
            <h3 className="about-subheading">Month 1: Python & Frontend Development</h3>
            <ul className="about-list">
              <li>Week 1: HTML, CSS Basics, Semantic HTML</li>
              <li>Week 2: CSS Flexbox, Responsive Design</li>
              <li>Week 3: Python Basics - Variables, Data Types, Loops, Functions, OOPs concepts.</li>
              <li>Week 4: Working with SQLite, Database CRUD Operations.</li>
            </ul>
          </div>
          <div>
            <h3 className="about-subheading">Month 2: Backend Development & Full Stack Integration</h3>
            <ul className="about-list">
              <li>Week 5:JavaScript Fundamentals, DOM Manipulation, Event Handling </li>
              <li>Week 6: Advanced JavaScript (ES6+), Node.js Basics, Express.js Setup</li>
              <li>Week 7:React.js basics, REST API Concepts </li>
              <li>Week 8: API Integration, Git & GitHub, Deployment, Final Full Stack Project Submission</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="about-section">
        <h2>Contact & Information</h2>
        <p>
          Website: <a href="https://cveysolutions.in" target="_blank" rel="noopener noreferrer" className="about-link">cveysolutions.in</a>
        </p>
        <p>
          Email: <a href="mailto:support@cveysolutions.in" className="about-link">support@cveysolutions.in</a>
        </p>
        <p>For more queries, reach out to our HR team via our website.</p>
      </section>

      <footer className="about-footer">
        © 2025 CVEY Solutions Pvt. Ltd. | All Rights Reserved
      </footer>
    </div>
  );
};

export default AboutInternship;
